import { __url, getSdpUrl } from '@99designs/i18n';

export type CtaLink = { url: string; label: string };

const CTA_DEFAULTS: Record<string, { label: string; getUrl: () => string }> = {
    LOGO_MAKER_URL: { label: 'Try Logomaker', getUrl: () => __url('/logomaker') },
    PRO_LOGO_DESIGN_URL: {
        label: 'Get a professional logo',
        getUrl: () => getSdpUrl('prologodesign'),
    },
};

export function resolveCtaUrl(
    urlKey: string | null | undefined,
    labelOverride?: string
): CtaLink | undefined {
    if (!urlKey || typeof urlKey !== 'string') return undefined;
    const entry = CTA_DEFAULTS[urlKey];
    if (!entry) return undefined;
    return { url: entry.getUrl(), label: labelOverride ?? entry.label };
}
